export default {
  online_shop: 'Tienda en línea',
  storefront: 'Escaparate',
  reservations: 'Reservas',
  import: 'Importación',
};
